module.exports = __webpack_public_path__ + "static/media/ic_keyboard_arrow_down_black_36px.f56a8d98.svg";